const AGELESS_HOST_PATTERNS = [/ageless\.ai$/i, /agelessai\.dev$/i, /agelessleads\.com$/i];

// TODO: remove query-param override before GA
const FORCE_AGELESS_PARAM = "forceAgeless";

export const isAgelessDomain = (): boolean => {
  if (typeof globalThis === "undefined") return false;

  const params = new URLSearchParams(globalThis.location.search);
  if (params.has(FORCE_AGELESS_PARAM)) return true;

  return AGELESS_HOST_PATTERNS.some((p) => p.test(globalThis.location.hostname));
};
